var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',_vm._b({staticClass:"c-link-card t-link",class:{
    'c-link-card--image': _vm.hasImage
  },attrs:{"to":_vm.url,"title":_vm.title,"aria-label":_vm.title}},'nuxt-link',_vm.$attrs,false),[(_vm.backgroundImage.src)?[_c('nuxt-img',_vm._b({staticClass:"c-link-card__image"},'nuxt-img',_vm.$getImgOptions(_vm.backgroundImage, {
        format: 'webp',
        alt: 'Image'
      }),false)),_vm._v(" "),_c('span',{class:_vm.imageTitleClass},[_vm._v(_vm._s(_vm.title))])]:_c('span',{class:_vm.titleClass},[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }